import React, { useState } from 'react';
import '../css/NewsletterSignup.css';

const NewsletterSignup = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically integrate with your newsletter service
        setStatus('success');
        setEmail('');
    };

    return (
        <div className="newsletter-container">
            <div className="newsletter-content">
                <h2>Subscribe to Tax Insights</h2>
                <p>Get weekly updates on tax-efficient investing strategies and market insights.</p>
                
                <form onSubmit={handleSubmit} className="newsletter-form">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                    />
                    <button type="submit">Subscribe</button>
                </form>
                
                {status === 'success' && (
                    <div className="newsletter-success">
                        Thank you for subscribing! Check your email to confirm.
                    </div>
                )}
                
                <div className="newsletter-features">
                    <div className="feature">
                        <span>✓</span> Weekly tax strategy tips
                    </div>
                    <div className="feature">
                        <span>✓</span> Market analysis
                    </div>
                    <div className="feature">
                        <span>✓</span> AI investing insights
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsletterSignup; 